import React from 'react';
export function HowToUse() {
  return <section className="bg-orange-50 py-8 sm:py-12 md:py-16" data-id="element-265">
      <div className="max-w-4xl mx-auto px-4" data-id="element-266">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8 md:mb-12 text-center" data-id="element-267">
          Cómo Usar el Sistema
        </h2>
        <div className="space-y-4 sm:space-y-6" data-id="element-268">
          <div className="flex gap-3 sm:gap-4" data-id="element-269">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-270">
              1
            </div>
            <div data-id="element-271">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-272">
                Domingo: Batch Cooking Express (60 min)
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-273">
                Dedica una hora el domingo para preparar las bases. Con nuestra
                guía paso a paso, tendrás arroz cocido, pollo listo, verduras
                cortadas y todo organizado para la semana.
              </p>
            </div>
          </div>
          <div className="flex gap-3 sm:gap-4" data-id="element-274">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-275">
              2
            </div>
            <div data-id="element-276">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-277">
                Lunes a Viernes: Sigue el Menú Semanal
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-278">
                Cada día ya tiene su receta asignada. Solo abre el plan, saca
                los ingredientes (que ya preparaste el domingo) y cocina en 15
                minutos exactos.
              </p>
            </div>
          </div>
          <div className="flex gap-3 sm:gap-4" data-id="element-279">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-280">
              3
            </div>
            <div data-id="element-281">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-282">
                Usa los Swaps Latinos cuando lo necesites
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-283">
                ¿No encuentras un ingrediente? Usa nuestra guía de sustituciones
                adaptadas a cada país de Latinoamérica. Siempre hay una
                alternativa local.
              </p>
            </div>
          </div>
          <div className="flex gap-3 sm:gap-4" data-id="element-284">
            <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-orange-600 text-white rounded-full flex items-center justify-center font-bold text-sm sm:text-base" data-id="element-285">
              4
            </div>
            <div data-id="element-286">
              <h3 className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-287">
                Disfruta la calma y la sonrisa de tu familia
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-288">
                Sin estrés. Sin improvisación. Sin protestas. Solo comida rica,
                hecha en minutos, y tiempo de calidad con los tuyos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}